import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation.json";
import el from "./locales/el/translation.json";
import it from "./locales/it/translation.json";
import de from "./locales/de/translation.json";

const savedLang = localStorage.getItem("lang") || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    el: { translation: el },
    it: { translation: it },
    de: { translation: de }
  },
  lng: savedLang,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});

export default i18n;